import Abstract from "./abstract";
import {commonEventEmitter} from "../../commonEventEmitter";

export default class Phone extends Abstract {
  constructor(loginContainer, formSelector, api, errorView) {
    super(loginContainer, formSelector);

    this._phoneNumber = ``;

    this._errorView = errorView;

    this._api = api;

    commonEventEmitter.on(`captcha.get`, this._onCaptchaGet);
    commonEventEmitter.on(`captcha.remove`, this._onCaptchaRemove);
  }

  getPhoneNumber() {
    return this._phoneNumber;
  }

  sendFormToServer() {
  }

  _onCaptchaRemove = () => {
    this._captcha.token = null;
  };

  _onCaptchaGet = (token, type) => {
    this._captcha.token = token ? token : null;

    if (type === this._captcha.type && this._validateInput(`tel`)) {
      this.sendFormToServer();
    }
  };

  _processingServerResponse(data) {
    super._processingServerResponse(data);

    if (data.code === 200) {
      if (this._errorView.isShowedError()) {
        this._errorView.hideError();
      }

      this._loginContainer.classList.add(`login__content--code`);
      this._loginContainer.querySelector(`.js-login-phone-number`).textContent = this._phoneNumber;
    } else if (data.code === 404) {
      this._errorView.showError(`Такого телефона не существует`);
    } else if (data.code === 400) {
      this._errorView.showError(`Телефон введен не верно`);
    } else if (data.code === 409) {
      this._errorView.showError(`Телефон уже существует`);
    } else {
      this._errorView.showError(data.answer);
    }
  }

  changeFormSubmitStatus(evt) {
    super.changeFormSubmitStatus(evt);

    if (!this._validateInput(`tel`)) {
      evt.preventDefault();
    } else {
      evt.preventDefault();
      this.sendFormToServer();
    }
  }
}
